import {
    Checkbox,
    TableCell,
    TableRow,
    IconButton,
    Tooltip,
    Chip
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { ICupom } from '../../../pedidos/interface/ICupom';
import { useDataHora } from '../../../core/hooks/useDataHora';
import { TipoCupom, TipoCupomDescricao } from '../../../pedidos/enum/TipoCupom';
import { useMoeda } from '../../../core/hooks/useMoeda';

interface CupomTableRowProps {
    cupom: ICupom;
    selecionado: boolean;
    toggleSelecionado: (uuid: string) => void;
    onEditar: (cupom: ICupom) => void;
    onExcluir: (cupom: ICupom) => void;
}

export const CupomTableRow = ({ 
    cupom, 
    selecionado, 
    toggleSelecionado, 
    onEditar,
    onExcluir
}: CupomTableRowProps) => {
    const { dataHoraBr } = useDataHora();
    const { real } = useMoeda();
    
    const isPorcentagem = cupom.tipo === TipoCupom.PORCENTAGEM || cupom.tipo === TipoCupom.PORCENTAGEM_PRODUTOS;
    
    const formatarValor = () => {
        if (cupom.tipo === TipoCupom.TAXA_ENTREGA) {
            return "-"; // Cupom de taxa de entrega não tem valor fixo
        }
        if (isPorcentagem) {
            return `${cupom.valor}%`;
        }
        return real(cupom.valor || 0);
    };
    
    const isExpirado = (): boolean => { 
        if (!cupom.dataValidade) return false;
        
        try {
            let dataValidade: Date;
            
            if (typeof cupom.dataValidade === 'string') {
                const dataStr = cupom.dataValidade.endsWith('Z') || cupom.dataValidade.includes('+') || cupom.dataValidade.includes('-', 10)
                    ? cupom.dataValidade
                    : cupom.dataValidade + 'Z';
                dataValidade = new Date(dataStr);
            } else {
                dataValidade = new Date(cupom.dataValidade);
            }
            
            if (isNaN(dataValidade.getTime())) return false;
            
            const agora = new Date();
            
            return dataValidade < agora;
        } catch (error) {
            console.error("Erro ao verificar data de validade:", error);
            return false;
        }
    };

    const expirado = isExpirado();
    
    const getStatus = () => {
        if (expirado) {
            return { label: "Expirado", color: "error" as const };
        }
        if (cupom.ativo) {
            return { label: "Ativo", color: "success" as const };
        }
        return { label: "Inativo", color: "default" as const };
    };
    
    const status = getStatus();
    
    return (
        <TableRow
            selected={selecionado}
            hover
            role="checkbox"
            aria-checked={selecionado}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    checked={selecionado}
                    onChange={() => cupom.uuid && toggleSelecionado(cupom.uuid)}
                />
            </TableCell>
            <TableCell align="left" width="15%">{cupom.codigo || "-"}</TableCell>
            <TableCell align="left" width="20%">{cupom.nome || "-"}</TableCell>
            <TableCell align="left" width="15%">{TipoCupomDescricao[cupom.tipo] || "-"}</TableCell>
            <TableCell align="left" width="15%">{formatarValor()}</TableCell>
            <TableCell align="center" width="10%">{cupom.limiteUsoPorUsuario ?? "-"}</TableCell>
            <TableCell align="center" width="10%">{cupom.totalUsos ?? 0}</TableCell>
            <TableCell align="center" width="10%">{cupom.clientesUnicos ?? 0}</TableCell>
            <TableCell align="left" width="15%">
                {cupom.dataValidade ? dataHoraBr(typeof cupom.dataValidade === 'string' ? cupom.dataValidade : cupom.dataValidade.toISOString()) : "-"}
            </TableCell>
            <TableCell align="center" width="10%">
                <Chip 
                    label={status.label} 
                    color={status.color}
                    size="small"
                />
            </TableCell>

        </TableRow>
    );
};
